<template>
  <div class="relative w-[100%] template-list-selection-area">
    <div class="flex items-center sticky top-0 z-10 bg-[#1E1E1E]">
      <div class="flex flex-1">
        <div
          class="search w-56 mx-5 my-2.5 px-2.5 py-3 bg-[#2C2C2C] inline-flex rounded-lg"
        >
          <Icon
            :width="20"
            :height="20"
            class="mr-2"
            icon="search.svg"
            fill="transparent"
          />
          <a-input
            v-model:value="inputSearchValue"
            :bordered="false"
            class="font-bold p-0"
            placeholder="关键字搜索"
          >
            <template #suffix>
              <Icon
                v-if="inputSearchValue.length"
                :width="14"
                :height="14"
                class="mr-2"
                icon="add3.svg"
                fill="transparent"
                @click="
                  () => {
                    inputSearchValue = '';
                  }
                "
              />
            </template>
          </a-input>
        </div>
      </div>
      <a-popover
        placement="bottomRight"
        :visible="selectObj.show"
        overlay-class-name="popClass"
      >
        <template #content>
          <modal-select-shape
            v-if="selectObj.show"
            @finish-select="finishSelect"
          />
        </template>
        <div
          class="bg-black-[#5f5f5f] cursor-pointer mr-5 flex items-center"
          :class="{ 'text-[#FFA552]': !!selectObj.selected.length }"
          @click.stop="selectWatchface"
        >
          <span class="mr-1">筛选</span>
          <div>
            <icon
              :icon="'choose.svg'"
              :width="20"
              :height="20"
              :fill="!!selectObj.selected.length ? '#FFA552' : 'none'"
            />
          </div>
        </div>
      </a-popover>
    </div>
    <a-collapse v-if="watchfaceList.length" v-model:activeKey="activeKey" ghost>
      <template #expandIcon="{ isActive }">
        <div
          class="duration-200"
          :style="{
            transform: `translate(0, ${isActive ? -6 : -4}px) rotate(${
              isActive ? 0 : -90
            }deg)`
          }"
        >
          <Icon
            :width="12"
            :height="12"
            icon="collapse-expand.svg"
            fill="#FFF"
          />
        </div>
      </template>
      <a-collapse-panel
        v-for="(categoryItems, category) in categorizedWatchfaces"
        :key="category"
        :name="category"
        :header="getProductNameIfNeed(category + '')"
      >
        <div class="_grid">
          <div v-for="item in categoryItems" :key="item.id">
            <DropDown :trigger="'contextmenu'" :menus="contextmenus(item)">
              <TemplateItem
                ref="templateItemRef"
                :template="item"
                :selected="frameSelected.has(item.id)"
                :contextmenus="contextmenus"
                :input-search-value="inputSearchValue"
                @rename-complete="handleRenameComplete"
                @contextmenu="
                  () => {
                    frameSelected = frameSelected.has(item.id)
                      ? new Set([...frameSelected, item.id])
                      : new Set([item.id]);
                  }
                "
                @dblclick="() => handleDblClick(item.id)"
              />
            </DropDown>
          </div>
        </div>
      </a-collapse-panel>
    </a-collapse>
    <div v-else class="flex justify-center items-center h-[464px]">
      <div>无模板数据</div>
    </div>
    <TemplateListSelection
      :selected="frameSelected"
      @update="
      (selected: Set<string>) => {
        frameSelected = selected;
      }
    "
      @update-templates="() => emit('update')"
    />
  </div>
  <modal-template-create
    ref="editTemplateRef"
    title="编辑模板"
    ok-text="编辑"
    @update="() => emit('update')"
  />
</template>
<script setup lang="ts">
import {
  TemplateService,
  WatchfaceTemplateItem
} from '@/services/template.service';
import { computed, onUnmounted, PropType, reactive, watch } from 'vue';
import { Modal, notification } from 'ant-design-vue';
import { cloneDeep } from 'lodash-es';
import { ref } from 'vue';
import { useShapeManage } from '@/hooks/use-shape-manage';
import { useWatchfaceDevices } from '@/hooks';

const props = defineProps({
  templates: {
    type: Array as PropType<WatchfaceTemplateItem[] | undefined>,
    default: () => []
  },
  activeIndex: {
    type: Number,
    default: 0
  }
});
const emit = defineEmits<{
  (event: 'update'): void;
  (event: 'closeModal'): void;
}>();

const { getProductNameIfNeed } = useWatchfaceDevices();

const templateService = new TemplateService();
const { addTemplate } = useShapeManage();
const templetTypes = TemplateService.types;
let inputSearchValue = ref('');
const watchfaceList = computed(() =>
  (cloneDeep(props.templates) ?? ([] as WatchfaceTemplateItem[]))
    .filter((item) =>
      inputSearchValue.value
        ? item.name?.includes(inputSearchValue.value)
        : true
    )
    .filter((item) => {
      return item.type == templetTypes[props.activeIndex];
    })
    .filter((item) =>
      selectObj.selected.length
        ? selectObj.selected.includes(item.deviceType ?? '')
        : true
    )
    .sort((a, b) => {
      return (b.updatedAt ?? 0) - (a.updatedAt ?? 0);
    })
);

const categorizedWatchfaces = computed(() => {
  const categorized: { [key: string]: Array<WatchfaceTemplateItem> } = {};
  for (const item of watchfaceList.value) {
    const deviceType = item.deviceType || 'Uncategorized';
    if (!categorized[deviceType]) {
      categorized[deviceType] = [];
    }
    categorized[deviceType].push(item);
  }
  return categorized;
});

//添加点击关闭
document.addEventListener('click', () => {
  if (selectObj.show) closeSelectWindow();
});
onUnmounted(() => {
  document.removeEventListener('click', () => {
    console.log('remove');
  });
});

const selectObj = reactive({
  show: false,
  selected: [] as string[]
});

const selectWatchface = () => {
  //筛选框
  if (selectObj.selected.length) {
    selectObj.show = false;
    selectObj.selected = [];
  } else {
    selectObj.show = true;
  }
};
const closeSelectWindow = () => {
  if (!selectObj.selected.length) {
    selectObj.show = false;
  }
};
const finishSelect = (selection: Array<string>) => {
  selectObj.selected = [...selection];
  selectObj.show = false;
};

//折叠面板的key
const activeKey = ref<string[]>([]);
// 第一次进来就打开所有折叠面板
watch(
  categorizedWatchfaces,
  (newCategorizedWatchfaces) => {
    activeKey.value = Object.keys(newCategorizedWatchfaces);
  },
  { immediate: true }
);
const editTemplateRef = ref();
const templateItemRef = ref();
//右击面板
const contextmenus = (item: WatchfaceTemplateItem) => {
  const res: (DropDownMenuItem & { hidden?: boolean })[] = [
    {
      title: '重命名',
      onClick: () => {
        const template = templateItemRef.value.find(
          (template: { id: string; startEditMode: () => void }) => {
            return template.id === item.id;
          }
        );
        template.startEditMode();
      }
    },
    {
      title: '编辑信息',
      onClick: () => {
        if (item) editTemplateRef.value.showEditModal(item);
      }
    },

    {
      title: '删除',
      onClick: () => {
        Modal.confirm({
          title: '是否删除该模板',
          okText: '确认',
          cancelText: '取消',
          onOk: async () => {
            await templateService.deleteTemplate(item.id);
            emit('update');
          }
        });
      }
    },
    {
      title: '导出该模板',
      onClick: async () => {
        await templateService.exportTemplates([item.id]);
      }
    }
  ];
  return res;
};

const frameSelected = ref(new Set<string>());

const handleRenameComplete = async () => {
  emit('update');
};

// 双击插入模板
const handleDblClick = async (id: string) => {
  try {
    await addTemplate(id);
    notification.success({ message: '添加模版成功' });
    // 防止闪烁
    setTimeout(() => emit('closeModal'), 100);
  } catch (e) {
    notification.error({ message: '添加模版失败' });
  }
};
</script>

<style scoped lang="less">
._grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 208px);
  column-gap: 30px;
  row-gap: 20px;
}

.template-list-selection-area :deep(.ant-collapse) {
  .ant-collapse-item > .ant-collapse-header {
    display: flex;
    margin: 12px 20px;
    padding: 10px 16px;
    font-size: 20px;
    font-weight: 500;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 1;
    border: 2px solid transparent;
    &:hover {
      border-radius: 8px;
      border: 2px solid #0d84f2;
    }
    .ant-collapse-arrow {
      margin-left: -11px;
      margin-right: 5px !important;
    }
    .ant-collapse-header-text {
      margin-top: 4px; // 调整文字的上边距
    }
  }
  .ant-collapse-content-box {
    padding: 8px 20px !important;
  }
}

.search {
  :deep(.ant-input) {
    font-size: 16px;
    line-height: 20px !important;
    font-weight: 400;
    height: 20px;
  }
  .ant-input-affix-wrapper:before {
    display: none;
  }
}
</style>
<style lang="less">
.popClass {
  .ant-popover-inner-content {
    padding: 12px 0px;
    .ant-collapse-header {
      padding: 12px 10px !important;
    }
  }
}
</style>
